import React, { useEffect, useLayoutEffect, useState } from 'react';
import NavigationPanel from './navigation-panel/NavigationPanel';
import AuthPanel from './auth-panel/AuthPanel';
import './Navbar.module.css';
import BurgerButton from './BurgerButton';
import { useSelector } from 'react-redux';


function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const isAuth = useSelector(store=>store.user.isAuth)
    const [bgColor, setBgColor] = useState('bg-unauth');
    const role = useSelector(store=>store.user.activeRole)

    useEffect(() => {
        const handleResize = (event) => {
            if (event.target.innerWidth > 1440) {
                setIsOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useLayoutEffect(() => {
      switch (role) {
          case 'school_admin':
              setBgColor('bg-school_admin');
              break;
          case 'expert_teacher':
              setBgColor('bg-expert_teacher');
              break;
          case 'expert_student':
              setBgColor('bg-expert_student');
              break;
          case 'private_user':
              setBgColor('bg-private_user');
              break;
          case 'superadmin':
              setBgColor('bg-superadmin');
              break;
          default:
              setBgColor('bg-dark-blue-color');
      }
    }, [role]);

    const toggleNavbar = async () => {
        setIsOpen(!isOpen);
    }

    return (
        <nav className={`flex justify-between items-center flex-wrap px-[10px] w-full border-b border-b-[#00000033] ${isOpen ? 'fixed bg-white z-50' : bgColor}`}>
            {isOpen
                ? (
                    <>
                        <div className="hidden tablet:flex flex-row">
                            <NavigationPanel/>
                        </div>

                        <div className="w-full flex justify-end desktop:justify-end">
                            <div className="flex mr-2 desktop:mr-0 ">
                                <AuthPanel isAuth={isAuth} role={role}/>
                            </div>
                            <BurgerButton toggleNavbar={toggleNavbar} isOpen={isOpen} setIsOpen={setIsOpen}/>
                        </div>
                    </>
                )
                : (
                    <>
                        <div className="hidden tablet:flex flex-row">
                            <NavigationPanel isAuth={isAuth}/>
                        </div>

                        <div className="flex justify-end desktop:justify-between mobile:w-full tablet:w-fit items-center">
                            <div className="hidden tablet:flex mr-2 desktop:mr-0">
                                <AuthPanel isAuth={isAuth} role={role}/>
                            </div>
                            <BurgerButton toggleNavbar={toggleNavbar} isOpen={isOpen} setIsOpen={setIsOpen} color={role}/>
                        </div>
                    </>
                )
            }

            {isOpen && (
                <div className="flex flex-col basis-full h-screen border-t border-t-[#00000033]">
                    <NavigationPanel toggle={toggleNavbar} isOpen={isOpen}/>
                </div>
            )}
        </nav>
    )
}

export default Navbar;
